// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"92":"lijnen","522":"hints","570":"memory","954":"vragen"}[chunkId] + "." + {"92":"1af1d080","522":"d13d4df5","570":"1918a151","954":"1af1d080"}[chunkId] + ".css";
};